import { render, staticRenderFns } from "./ColorIcon.vue?vue&type=template&id=1e51a0c1&"
import script from "./ColorIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ColorIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports